import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FairForm2Service {
  readonly #http = inject(HttpClient);

  submit(data: unknown) {
    return this.#http.post('api/fair-form2', data);
  }
}
